import { render, staticRenderFns } from "./AncillarySeatMapPassengerNarrow.vue?vue&type=template&id=48678112&scoped=true"
import script from "./AncillarySeatMapPassengerNarrow.vue?vue&type=script&lang=js"
export * from "./AncillarySeatMapPassengerNarrow.vue?vue&type=script&lang=js"
import style0 from "./AncillarySeatMapPassengerNarrow.vue?vue&type=style&index=0&id=48678112&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48678112",
  null
  
)

export default component.exports